import { iconLibrary } from '@web/utils';

import * as fas from 'components/faIcons/fasIcons';
import * as fab from 'components/faIcons/fabIcons';

iconLibrary.add(fas, fab);
